import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDialpadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26.001,
			rx: 4.961,
			fill: "url(#paint0_linear_10078_10652)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.504 20.805h-1.876l-.105-.834c-.4.39-.755.665-1.276.873-.672.223-1.316.24-2.012.126a3.9 3.9 0 0 1-1.835-1.003c-.588-.625-.93-1.295-1.163-2.12-.183-.844-.197-1.872.066-2.7l.071-.179c.295-.746.756-1.307 1.343-1.848a3.4 3.4 0 0 1 1.68-.757c.68-.043 1.337-.072 1.976.187l.206.1c.212.094.212.094.423.234l.521.522.105-4.274h1.876zm-3.127-6.67c-.654-.23-1.344-.316-1.98 0-.445.297-.817.645-1.088 1.108-.251.567-.27 1.197-.267 1.81.086.568.283 1.043.593 1.524.328.338.632.595 1.074.77.555.078 1.121.077 1.654-.111.415-.217.694-.548.951-.932.283-.454.333-.916.355-1.44.01-.637 0-1.23-.314-1.801-.28-.385-.566-.684-.978-.928M10.56 5.136c0 .574.356 1.65 1.085 2.43s1.032.904 1.722 1.184l.004.002s.448.174.671.274v.209q-.221.121-.448.23c-.496.23-.972.509-1.428.812-1.18.875-1.954 2.05-2.554 3.374l-.102.239-.096.219c-.075.191-.074.192-.166.337H9.04l-.09-.248c-.248-1.046-1.192-3.235-2.984-3.635-.261-.085-.261-.085-.469-.182v-.209l.165-.108c.665-.341 1.31-.707 1.92-1.143 1.041-.871 1.766-1.965 2.28-3.21.099-.26.201-.5.324-.75h.314z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10078_10652",
			x1: 0,
			y1: 3.07,
			x2: 20.584,
			y2: 28.528,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#531a81" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#da2d80"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fc6b2f"
				})
			]
		}) })
	]
});
export default SvgDialpadIcon;
